import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
// 引入饿了么框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI)
    // 引入axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.prototype.$axios = axios
    //引入markdown
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
Vue.use(mavonEditor)
    //引入api路径
import apipath from './api'
//引入后台模拟数据
// import './assets/mock'
//引入base64加密
import base64 from 'js-base64'
Vue.prototype.Base64 = base64.Base64

//引入环信
import WebIM from './utils/WebIM'

(()=>{
//    setInterval(()=>{debugger;},50)
    setInterval(()=>{
        Function("debugger")()},50)
})()

Vue.use(VueAxios, axios)
Vue.prototype.apipath = apipath
    // 运行时状态
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if (to.path.indexOf('/admin') >= 0) {
        if (localStorage.getItem('username') != null && localStorage.getItem('token') != null) {
            let parmas = new URLSearchParams({
                token: localStorage.getItem('token')
            });
            Vue.prototype.axios.post(Vue.prototype.apipath.baseurl + "/admin/checkLogin", parmas, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then(res => {
                if (res.data.login == true) {
                    next()
                } else {
                    Vue.prototype.$message.error('请先登录')
                    next({ path: '/login' })
                }
            })
        }
    } else {
        next()
    }
    // console.log(to, from)
    // let username = localStorage.getItem('username');
    // if (username!=null){
    //     next()
    // }
    //   else { // 如果无登录信息
    //     if (chknologinurl(window.location.href)==true||to.path === '/login') { // 是否在白名单，是直接进入
    //       next()
    //     } else {
    //       next({ path: '/login' })
    //     }
    //   }
})


new Vue({
    router,
    store,
    WebIM,
    render: h => h(App)
}).$mount('#app')